import { Component, useRef } from "react";
import { createRef, useState } from "react";
import React from 'react'
import Draggable from "react-draggable";
import { getBoundingClientRect } from "../../utils/functions";

class MovingCircle extends Component {


    state = {
        showTaskDetail: false,
        taskMenu: false,
        prevLeft: 0,
        prevright: 0,
        direction: "",
        prevWidth: 0,
        prevMouseX: 0


    }
    InputFile = React.createRef();
    scircleRef = React.createRef();
    rightHandlerRef = React.createRef();
    leftHandlerRef = React.createRef();

    onMouseDown = (e, direction) => {
        let srollLeft = document.getElementById('gantt').scrollLeft
        let listDiv = document.getElementById("list-items-holde");
        let listBounding = listDiv.getBoundingClientRect(e);
        let mousePosition = e.clientX - listBounding.right
        let circleLeft = Number(this.circleRef.style.left.split("px")[0])
        console.log(direction, "direction")
        this.setState(
            {
                direction,
                prevMouseX: mousePosition,
                prevLeft: circleLeft,
                prevright: Number(this.circleRef.style.right.split("px")[0]),
                prevWidth: this.circleRef.getBoundingClientRect().width
            },
            () => {
                window.addEventListener("mousemove", this.onMouseMove);
                window.addEventListener("mouseup", this.onMouseUp);
                this.circleRef.addEventListener("mouseup", this.onMouseUp);

            }
        );

    }

    onMouseMove = (e) => {
        let srollLeft = document.getElementById('gantt').scrollLeft
        let listDiv = document.getElementById("list-items-holde");
        let listBounding = listDiv.getBoundingClientRect();
        let mousePosition = e.clientX - listBounding.right;
        let leftHandlerBounding = this.leftHandlerRef.getBoundingClientRect();
        let rightHandlerRef = this.rightHandlerRef.getBoundingClientRect();
        let movingCircle = this.circleRef.getBoundingClientRect()
        let direction = this.state.direction;

        console.log(direction)

        if (direction == 'left' && movingCircle.width >= 25 && mousePosition > 0) {
            let prevLeft = this.state.prevLeft;
            let prevMouseX = this.state.prevMouseX;
            let prevWidth = this.state.prevWidth;
            let dateDifference = prevMouseX - e.clientX;
            let daysChangeNumber = Math.round(dateDifference / 25);
            let taskId = this.props.id;
            if (prevWidth + prevMouseX - mousePosition >= 25) {
                this.circleRef.style.left =
                    prevLeft + (mousePosition - prevMouseX) + "px";
                this.circleRef.style.width =
                    prevWidth + (prevMouseX - mousePosition) + "px";
            }
        }

        if (direction == 'right' && movingCircle.width >= 25 && mousePosition < this.props.holderWidth) {
            console.log('inside');
            let prevLeft = this.state.prevLeft;
            let prevMouseX = this.state.prevMouseX;
            let prevWidth = this.state.prevWidth;
            let dateDifference = prevMouseX - e.clientX;
            let daysChangeNumber = Math.round(dateDifference / 25);
            let taskId = this.props.id;
            console.log(prevWidth + (mousePosition - prevMouseX))
            if (prevWidth + (mousePosition - prevMouseX) >= 25) {
                this.circleRef.style.width =
                    prevWidth + (mousePosition - prevMouseX) + "px";
            }
        }
        if (movingCircle.width > 10) {
            this.setState({
                showTaskDetail: true
            })
        }
        else if (movingCircle.width < 5) {
            this.setState({
                showTaskDetail: false
            })

        }

    }

    onMouseUp = () => {
        let inintialWdith = this.state.prevWidth;
        let currentWidth = this.circleRef && this.circleRef.getBoundingClientRect().width;
        let Indexdifference = Math.round(currentWidth / 25);
        let finalWdith = Indexdifference * 25;
        let widthDifference = currentWidth - finalWdith;
        let direction = this.state.direction;
        if (direction == 'left' && this.circleRef) {
            this.circleRef.style.width = finalWdith + "px";
            this.circleRef.style.left = Number(this.circleRef.style.left.split("px")[0]) + widthDifference + "px";
        }
        if (direction == 'right' && this.circleRef) {
            this.circleRef.style.width = finalWdith + "px";
        }
        this.circleRef && this.circleRef.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mousemove", this.onMouseMove);
    }
    // eventControl = (event, info) => {
    //     console.log('Event name: ', event.type);
    //     console.log(event, info);
    // }
    render() {
        const { id, showTaskHanles, changeTaskTimeStamp } = this.props;
        return (

            <Draggable
                axis="x"
                bounds={{ left: 0, top: 0, bottom: 0, right: "100%" }}
            >
                <div
                    ref={(el) => this.circleRef = el}
                    id={id}
                    style={{
                        position: "absolute",
                        borderRadius: 50,
                    }}
                    className="moving-task"
                >

                    <div className="handlers-holder">
                        <div
                            style={{ cursor: !showTaskHanles ? "ew-resize" : "default", }}
                            onMouseDown={(e) => {
                                this.onMouseDown(e, 'left')
                                e.stopPropagation();
                            }}
                            onMouseUp={(e) => {
                                this.onMouseUp(e, 'left')
                                e.stopPropagation();
                            }
                            }
                            className="circle-left-handler"
                            ref={(el) => (this.leftHandlerRef = el)}
                        >
                        </div>
                        <div
                            onMouseDown={(e) => {
                                this.onMouseDown(e, 'right')
                                e.stopPropagation();

                            }}
                            onMouseUp={(e) => {
                                this.onMouseUp(e, 'right')
                                e.stopPropagation();

                            }}
                            style={{ cursor: !showTaskHanles ? "ew-resize" : "default", }}
                            className="circle-right-handler"
                            ref={(el) => (this.rightHandlerRef = el)}

                        ></div>
                        {this.state.showTaskDetail ?
                            <div className="task-detail">
                                <img src="/images/profile-men-1.svg" alt="profile" style={{
                                    width: "21px", height: "21px",
                                    marginLeft: "1rem",
                                    marginTop: ".1rem"
                                }} />
                                <div

                                    style={{
                                        width: "260px", height: "20px",
                                        marginTop: ".19rem"
                                    }}>{this.props.title}</div>

                            </div>
                            :
                            ""}
                    </div>

                </div>

            </Draggable>
        );
    }
};

export default MovingCircle;
